import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { updateState } from "../../../redux/commonSlice";
import {   downloadZippedMedia } from "../../../services/api";
import { useState } from "react";
import { useEffect } from "react";
import { downloadS3File } from "../../../utils/commonServices";
import { useRef } from "react";

export default (downloadZippedMediaID, enableDownload, setEnableDownload)=> {

    const dispatch = useDispatch();
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const mediaFilesReducer = useSelector((state) => state.mediaFilesReducer);
 

    
    const [downloadZippedMediaStatus, setDownloadZippedMediaStatus] =useState('')
    const [zipUrl, setZipUrl] = useState('')
    const [downloadLink, setDownloadLink] = useState('')
    const enableRef = useRef(enableDownload)
    const downloadRef = useRef(downloadLink)
    // const [enableDownload, setEnableDownload] = useState(enable)

const {
    data: downloadZippedMediaData,
    isLoading: downloadZippedMediaLoading,
    error: downloadZippedMediaError,
    refetch: downloadZippedMediaRefetch,
  } = useQuery(
    [
      `downloadZippedFile${downloadZippedMediaID}`,
      downloadZippedMediaID,
    ],
    () => downloadZippedMedia({zipped_file_id: downloadZippedMediaID }),
    { enabled: enableDownload, retry: false }
  );


  

    useEffect(()=> {
      const intervalId = setInterval( async () => {
        if(enableRef.current == true && downloadRef.current == ''){ 
          // setEnableDownload(true)
          await downloadZippedMediaRefetch()
          //console.log('refetching url')
        }else{
          // setEnableDownload(false)
        }
       }, 500);
      
       return () => clearInterval(intervalId);
    
     },[])

   
     //console.log({enableDownload})

 

     useEffect(() => {
      if(downloadZippedMediaLoading == true){
        setDownloadZippedMediaStatus('loading')
      }
    }, [downloadZippedMediaLoading]);


  useEffect(()=> {
    if(downloadZippedMediaData) {
      const responseObject = downloadZippedMediaData.data.data
     // console.log(responseObject)
      
        if( responseObject.download_link !== ''){
            setEnableDownload(false)
            setZipUrl(responseObject.zip_url)
            setDownloadLink(responseObject.download_link)
            setTimeout(()=> {
              downloadS3File(responseObject.download_link)
            }, 2000)
           // console.log(responseObject.download_link)
            setDownloadZippedMediaStatus("success");
        }    
    }
  }, [downloadZippedMediaData])




return [zipUrl, downloadLink, downloadZippedMediaStatus, downloadZippedMediaRefetch]

}